module.exports = __webpack_public_path__ + "img/alert-octagon.aed619d3.svg";